import React, { useState } from 'react'
import { useRouter } from 'next/router';
import { articles } from '@/types/Blog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

export const SearchBar = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const router = useRouter();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      router.push(`/iit-news/search?q=${encodeURIComponent(searchQuery)}`);
    }
  };

  return (
    <div className="w-full mb-5">
      <form onSubmit={handleSearch} className="flex w-full">
        <div className='flex-1 relative'>
          <input
            type="text"
            placeholder="Cari Pencarian"
            className="border border-gray-300 rounded-full rounded-r-none px-4 py-3 w-full h-12 focus:outline-none"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          {articles.filter(item => {
            const searchTerm = searchQuery.toLowerCase();
            const articleTitle = item.title.toLowerCase();
            return searchTerm && articleTitle.startsWith(searchTerm);
          }).length > 0 && (
            <div className="flex flex-col col-span-1 border rounded-md bg-white w-full max-h-64 overflow-y-auto gap-y-1 hide-scrollbar absolute z-30">
              {articles
                .filter(item => {
                  const searchTerm = searchQuery.toLowerCase();
                  const articleTitle = item.title.toLowerCase();
                  return searchTerm && articleTitle.startsWith(searchTerm);
                })
                .map(item => (
                  <div
                    key={item.id}
                    className="w-full p-2 cursor-pointer hover:bg-blue-50"
                    onClick={() => setSearchQuery(item.title)}
                  >
                    {item.title}
                  </div>
                ))}
            </div>
          )}
        </div>

        <button 
          type="submit"
          className="bg-defaultBlue text-white rounded-r-full px-6 py-3 border-l-0 border h-12 border-defaultBlue font-semibold"
        >
          <FontAwesomeIcon icon={faSearch} style={{ color: "white", }} className='mr-2' />
        </button>
      </form>
    </div>
  )
}